import "core-js/modules/es.function.name.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setTimeout } from 'timers';
import { colors } from '../theme/colors';
import { When } from '../utils/when';
import { Text } from '../text/text';
import { Textarea } from './components/textarea';
import { Label } from './components/label';
import { ContainerVertical } from '../layout/container-vertical';
import { HSpacer } from '../spacers/spacer-horizontal';
export var TextArea = function TextArea(props) {
  var _props$rows, _props$isRequired;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      maxLengthError = _useState[0],
      setMaxLengthError = _useState[1];

  var handleChange = function handleChange(event) {
    var text = event.target.value;

    if (props.maxLength) {
      if (text.length <= props.maxLength) {
        props.onChange(text);
        setMaxLengthError(false);
      } else {
        setMaxLengthError(true);
        setTimeout(function () {
          return setMaxLengthError(false);
        }, 2000);
      }
    } else {
      props.onChange(text);
    }
  };

  return /*#__PURE__*/_jsxs(ContainerVertical, {
    align: "flex-start",
    custom: true,
    input: true,
    children: [/*#__PURE__*/_jsx(Label, {
      htmlFor: props.name,
      children: props.label
    }), /*#__PURE__*/_jsx(HSpacer, {
      space: "8px"
    }), /*#__PURE__*/_jsx(Textarea, {
      id: props.id,
      placeholder: props.placeholder,
      name: props.name,
      rows: (_props$rows = props.rows) !== null && _props$rows !== void 0 ? _props$rows : 2,
      value: props.value,
      onChange: handleChange,
      error: props.error || maxLengthError,
      maxWidth: props.maxWidth,
      required: (_props$isRequired = props.isRequired) !== null && _props$isRequired !== void 0 ? _props$isRequired : false
    }), /*#__PURE__*/_jsxs(When, {
      value: maxLengthError,
      children: [/*#__PURE__*/_jsx(HSpacer, {
        space: "4px"
      }), /*#__PURE__*/_jsx(Text, {
        color: colors.red,
        children: t('MAXLENGTH_ERROR')
      })]
    })]
  });
};